import {useAppSelector} from '@/hooks';

export const usePosterHasAudio = (): boolean => {
  const audioHashmap = useAppSelector((state) => {
    const currentPageId = state.posterEditor.currentPageId;
    return state.posterEditor.posterObject?.pages?.pagesHashMap?.[currentPageId]?.audioClips.audioItemsHashMap;
  });

  if (!audioHashmap) {
    return false;
  }

  return Object.keys(audioHashmap).length > 0;
};
